import { render, staticRenderFns } from "./RegistrationIncomeReuploadPage.vue?vue&type=template&id=79c2c0ff"
import script from "./RegistrationIncomeReuploadPage.vue?vue&type=script&lang=ts"
export * from "./RegistrationIncomeReuploadPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports